import { toast } from 'react-toastify';
import * as Sentry from '@sentry/astro';

const AddToWatchList = ({ token, ticker, wrapperClassName = 'flex mt-2 md:justify-start justify-end' }) => {
	const addWatchList = () => {
		if (token === '') {
			window.location.href = '/login/';
		}

		const jsonData = JSON.stringify({ ticker: ticker });
		fetch(`${import.meta.env.PUBLIC_API_URL}/client/watch-list`, {
			method: 'POST',
			credentials: 'include',
			headers: {
				Authorization: `Bearer ${token.value}`,
			},
			body: jsonData,
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.hasOwnProperty('errors')) {
					toast.warning(data.errors[0]);
				} else {
					toast.success(`${ticker} added to your Watch List`);
				}
			})
			.catch((error) => {
				toast.error(`Error happened`);
				Sentry.captureException(error);
			});
	};

	return (
		<div className={wrapperClassName}>
			<button
				type="button"
				onClick={addWatchList}
				className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:pointer-events-none dark:text-blue-500 dark:hover:text-blue-400 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
			>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="w-4 h-4">
					<path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
				</svg>
				Add to Watch List
			</button>
		</div>
	);
};

export default AddToWatchList;
